const routes = {
  root: "/",
  cart: "/cart",
  checkout: "/checkout",
  products: {
    index: "/products",
    show: "/products/:slug",
  },
};

export default routes;
